import { configureStore } from '@reduxjs/toolkit';
import fileBrowserReducer from '../components/data-management/file-browser-slice';
import searchCatalogReducer from '../components/search-catalog/search-catalog-slice';
import searchCatalogCAOMReducer from '../components/search-catalog-caom/search-catalog-caom-slice';
import interactiveSessionsReducer from '../components/interactive-sessions/interactive-sessions-slice';
import searchComputeReducer from '../components/search-compute/search-compute-slice';
import computeJobsReducer from '../components/compute-jobs/compute-jobs-slice';
import globalReducer from './global-slice';
import settingsReducer from './settings-slice';
import dataReducer from './data-slice';
import contextMenuReducer from '../components/menus/context-menu-slice';
import appReducer from '../app-slice';
import homeReducer from '../components/home/home-slice';
import panelsReducer from '../components/panels/panels-slice';
import projectReducer from '../components/project/project-slice';

export const store = configureStore({
  reducer: {
    fileBrowser: fileBrowserReducer,
    searchCatalog: searchCatalogReducer,
    searchCatalogCAOM: searchCatalogCAOMReducer,
    interactiveSessions: interactiveSessionsReducer,
    searchCompute: searchComputeReducer,
    computeJobs: computeJobsReducer,
    global: globalReducer,
    settings: settingsReducer,
    data: dataReducer,
    app: appReducer,
    contextMenu: contextMenuReducer,
    panels: panelsReducer,
    home: homeReducer,
    project: projectReducer,
  },
});

// infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// inferred type: {fileBrowser: FileBrowserState, global: GlobalState}
export type AppDispatch = typeof store.dispatch;
